import { compareUnorderedArrays } from '../../../utils/arrayUtils';
import {
    isDateAfter,
    isDateEarlier,
    isDatePast,
    isTimePast,
    reverseFormatDate
} from '../../../utils/dateFunctions';
import { REMOTE_CALL_URL_PROVIDERS } from '../../../utils/formValidation/commonConstants';
import {
    NO_UPDATE_ERROR,
    PAST_DATE_ERROR
} from '../../../utils/formValidation/commonErrorConstants';
import {
    getDateMaxMessage,
    getDateMaxOrSameMessage,
    getDateMinMessage,
    getFormatMessage,
    getReqMessage,
    getSelectMessage,
    getUnknownMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import { regExps } from '../../../utils/formValidation/validationPatterns';

export const ADDITIONAL_DETAILS_LIMIT = 100;

export const validateLocation = (locationId, errors) => {
    if (!locationId)
        return {
            ...errors,
            locationId: { error: true, message: getSelectMessage('location') }
        };
    return errors;
};

export const validateRemoteCallUrl = (remoteCallUrl, errors) => {
    if (!REMOTE_CALL_URL_PROVIDERS.some((el) => remoteCallUrl?.includes(el))) {
        return {
            ...errors,
            remoteCallUrl: { error: true, message: getUnknownMessage('Remote call provider') }
        };
    } else if (!remoteCallUrl.match(regExps.SECURE_URL_R)) {
        return {
            ...errors,
            remoteCallUrl: { error: true, message: getFormatMessage('Remote call URL') }
        };
    }
    return errors;
};

export const validateAppointmentType = (typeId, errors, key = 'typeId') => {
    if (!typeId)
        return {
            ...errors,
            [key]: { error: true, message: getSelectMessage('appointment type', 'an') }
        };
    return errors;
};

export const validateService = (serviceId, errors) => {
    if (!serviceId)
        return {
            ...errors,
            serviceId: { error: true, message: getSelectMessage('service') }
        };
    return errors;
};

export const validateTeam = (teamId, errors) => {
    if (!teamId)
        return {
            ...errors,
            teamId: { error: true, message: getSelectMessage('team') }
        };
    return errors;
};

export const validateAdviser = (userId, errors) => {
    if (!userId)
        return {
            ...errors,
            userId: { error: true, message: getSelectMessage('adviser', 'an') }
        };
    return errors;
};

export const validateParticipant = (participantId, errors) => {
    if (!participantId)
        return {
            ...errors,
            participantId: { error: true, message: getSelectMessage('participant') }
        };
    return errors;
};

export const validateUserEventType = (userEventTypeId, errors) => {
    if (!userEventTypeId)
        return {
            ...errors,
            userEventTypeId: { error: true, message: getSelectMessage('user event type') }
        };
    return errors;
};

export const validateStartTime = (startTime, endTime, errors) => {
    if (startTime >= endTime)
        return {
            ...errors,
            startTime: { error: true, message: getDateMaxMessage(endTime) }
        };
    return errors;
};

export const validateEndTime = (endTime, startTime, errors) => {
    if (endTime <= startTime)
        return {
            ...errors,
            endTime: { error: true, message: getDateMinMessage(startTime) }
        };
    return errors;
};

export const validateDate = (date, errors) => {
    if (!date) {
        return {
            ...errors,
            date: { error: true, message: getReqMessage('Date') }
        };
    }
    return errors;
};

export const checkForPastDate = (date, errors) => {
    if (isDatePast(date)) {
        return {
            ...errors,
            date: { error: true, message: PAST_DATE_ERROR }
        };
    }
    return errors;
};

export const checkForPastTime = (date, startTime, errors) => {
    if (isTimePast(`${date}T${startTime}`)) {
        return {
            ...errors,
            startTime: { error: true, message: getDateMinMessage('the current time') }
        };
    }
    return errors;
};

export const validateRepeatUntilDate = (repeatUntilDate, date, errors) => {
    if (!repeatUntilDate) {
        return {
            ...errors,
            repeatUntilDate: { error: true, message: getReqMessage('Until Date') }
        };
    } else if (!isDateAfter(repeatUntilDate, date)) {
        return {
            ...errors,
            repeatUntilDate: { error: true, message: getDateMinMessage('date set above') }
        };
    }
    return errors;
};

export const validateDateOnOrBeforeRepeatUntilDate = (date, repeatUntilDate, errors) => {
    if (isDateAfter(date, repeatUntilDate)) {
        return {
            ...errors,
            date: {
                error: true,
                message: getDateMaxOrSameMessage(
                    `Repeat Until Date: ${reverseFormatDate(repeatUntilDate)}`
                )
            }
        };
    }
    return errors;
};

export const validateReferralDate = (date, errors, referralDate) => {
    if (isDateEarlier(referralDate, date)) {
        return {
            ...errors,
            date: {
                error: true,
                message: getDateMinMessage(`referral date: ${reverseFormatDate(referralDate)}`)
            }
        };
    }
    return errors;
};

export const checkDiff = (newEntry, initialStateOnEntry, errors) => {
    if (compareUnorderedArrays(Object.values(newEntry), Object.values(initialStateOnEntry))) {
        return {
            ...errors,
            button: { error: true, message: NO_UPDATE_ERROR }
        };
    }
    return errors;
};
